// FIXME: this is strictly to add support for the old DB schema. Should remove once schema is optimized
// The only reason we would keep this is if we want strict logic for some nodes types (like no attachments for certain nodes)
export enum NodeType {
  CATEGORY = 'Category',
  MASTER = 'Survey Code',
  SURVEY_SUB_TYPE = 'Survey Sub Type',
}

export const getParentType = (type: NodeType) => {
  switch (type) {
    case NodeType.CATEGORY:
      return null;
    case NodeType.MASTER:
      return NodeType.CATEGORY;
    case NodeType.SURVEY_SUB_TYPE:
      return NodeType.MASTER;
    default:
      return null;
  }
};

export const getChildType = (type: NodeType) => {
  switch (type) {
    case NodeType.CATEGORY:
      return NodeType.MASTER;
    case NodeType.MASTER:
      return NodeType.SURVEY_SUB_TYPE;
    case NodeType.SURVEY_SUB_TYPE:
    default:
      return null;
  }
};
